// طراز أزرار 3D Neo مطابق لبطاقات الصفحة الرئيسية (لون كامل + ظل ثلاثي الأبعاد).
export const TILE_3D = {
  boxShadow:
    "0 14px 28px rgba(0,0,0,0.32), 0 8px 12px rgba(0,0,0,0.20),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.28), inset 0 -4px 10px rgba(0,0,0,0.18)",
};

export const tileBtn = (tone) =>
  "rounded-2xl px-5 py-3 text-sm font-bold text-white select-none touch-manipulation "
  + "transition-transform duration-300 hover:-translate-y-0.5 active:translate-y-0 "
  + `disabled:opacity-50 disabled:pointer-events-none ${tone}`;
